import React from 'react';
import { View, Text, StyleSheet, StyleProp, ViewStyle } from 'react-native';
import { Colors, FontSize, FontWeight, Radii, ChipColors, ChipTone } from '../theme/tokens';

interface ChipProps {
  label: string;
  tone?: ChipTone;
  solid?: boolean;
  outline?: boolean;
  size?: 'sm' | 'md';
  dot?: boolean;
  style?: StyleProp<ViewStyle>;
}

export function Chip({ label, tone = 'default', solid, outline, size = 'sm', dot, style }: ChipProps) {
  const c = ChipColors[tone];
  const h = size === 'md' ? 26 : 22;
  const px = size === 'md' ? 12 : 9;
  const fs = size === 'md' ? FontSize.sm : FontSize.xs;

  const bg = solid ? c.color : outline ? 'transparent' : c.bg;
  const border = solid ? c.color : c.border;
  const textColor = solid ? '#fff' : c.color;

  return (
    <View style={[styles.base, { height: h, paddingHorizontal: px, backgroundColor: bg, borderColor: border }, style]}>
      {dot && <View style={[styles.dot, { backgroundColor: c.dot }]} />}
      <Text style={[styles.text, { fontSize: fs, color: textColor }]}>{label}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  base: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    borderRadius: Radii.full,
    borderWidth: 1,
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: 3,
  },
  text: {
    fontWeight: FontWeight.medium,
  },
});
